<template>
    <div class="home">
        <Topbar />
        <div class="container-fluid text-left" style="margin-top: 72px; justify-content: center; display: flex">
            <!-- Content Row -->
            <div class="card shadow mb-4 col-md-6 p-0">
                <div class="card-header py-2" :style="{ backgroundColor: moduloAtual().color }">
                    <h6 class="m-0 font-weight-bold text-white">
                        <div>
                            {{ title.text }}: Selecione a lista
                            <div v-show="carregando" class="spinner-grow">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </h6>
                </div>
                <fieldset :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark">
                        <div>
                            <div class="text-center">
                                <div style="display: flex;">
                                    <div class="col p-0">
                                        <InputDefaultApp
                                            inputPlaceHolderSufixo="Digite a lista aqui"
                                            titleScan="Escanear lista"
                                            typeInputMode="numeric"
                                            @displayScanFunction="okConfimarLista"
                                            :enterKey="(e) => okConfimarLista(e.target.value)"
                                            idInput="pesquisa"
                                            :errorMessage="errors.pesquisa ? errors.pesquisa[0] : ''"
                                        >
                                        </InputDefaultApp>
                                    </div>
                                </div>
                            </div>

                            <div class="collapse" id="filtrocardImportacao">
                                <div class="card card-body bg-light">
                                    <div class="row">
                                        <div class="custom-file form-group col-md-5 ml-2 mt-2">
                                            <input type="hidden" name="arquivo" id="arquivo" v-model="arquivoNome" />
                                            <input
                                                type="file"
                                                class="custom-file-input"
                                                name="files[]"
                                                @change="handleEscolhaArquivo"
                                                id="userfile"
                                                multiple
                                            />
                                            <label
                                                class="custom-file-label"
                                                for="userfile"
                                                data-browse="Buscar"
                                                id="etiqueta"
                                            >
                                                {{ arquivoLabel }}</label
                                            >
                                        </div>
                                        <button
                                            type="submit"
                                            id="btn_save"
                                            name="btn_save"
                                            value="UPLOAD"
                                            class="btn btn-success ml-2 mt-2"
                                            @click="importarPlanilha"
                                            :disabled="arquivos == null"
                                        >
                                            Importar
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <hr />
                            <div class="row">
                                <div class="col-lg-12 table-responsive">
                                    <table class="table table-sm table-striped table-bordered table-hover">
                                        <thead class="d-none">
                                            <tr>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="line in dados"
                                                :key="line[idname]"
                                                :style="{
                                                    backgroundColor: '#' + line.statusbackground,
                                                    color: '#' + line.statuscolor,
                                                }"
                                            >

                                                <td  @click="() => confimarLista(line)">
                                                    <div>
                                                        <div style="display: flex; justify-content: space-between">
                                                            <span class="text-left text-primary">{{
                                                                line.fantasia
                                                            }}</span>
                                                            <span class="text-right text-secondary">{{
                                                                dateFormat(line.dataabertura.substring(0, 10))
                                                            }}</span>
                                                        </div>
                                                        <div style="display: flex; justify-content: space-between">
                                                            <span class="text-left">{{ line.idlistascancelamento }}</span>
                                                            <span class="text-right text-secondary">{{
                                                                line.nome
                                                            }}</span>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </div>
        </div>
        <ForbiddenModal />
        <LogoutModal />
        <Modal
            v-if="lista"
            id="confirmarLista"
            title="Confirmar Lista"
            :confirmFunction="() => okConfimarLista()"
            :carregando="carregando"
        >
            Confirma o início da separação da lista <br/> {{ lista.idlistascancelamento }} - {{ lista.fantasia }}?
        </Modal>
        <Modal
            id="scanModal"
            title="Escanear"
            :carregando="carregando"
            :buttonList="[]"
            :cancelFunction="fecharScan"
        >
            <StreamBarcodeReader v-if="scanAberto" @decode="onDecode" @loaded="onLoaded" @error="onError"></StreamBarcodeReader>
        </Modal>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from "@/components/Topbar.vue";
import LogoutModal from "@/components/LogoutModal.vue";
import ViewMixin from "./ViewMixin";
import api from "../services/api";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    EnderecoDiferenteException,
    ListaConcluidaException,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
    ValidationException,
} from "../services/exceptions";
import { enterKey, dateFormat, selecionar, scrollToTop } from "../utils";
import ForbiddenModal from "../components/ForbiddenModal.vue";
import InputDefaultApp from "../components/InputDefaultApp.vue";
import Modal from "../components/Modal.vue";
import Audio from "../services/audioService";

export default {
    name: "Cancelamento",
    mixins: [ViewMixin],
    components: {
        Topbar,
        LogoutModal,
        ForbiddenModal,
        Modal,
        InputDefaultApp
    },
    data: () => {
        return {
            idname: "idlista",
            baseUrl: "cancelamento",
            title: {
                icon: "fas fa-cash-register",
                text: "Cancelamento",
            },
            sort: "nome",
            sortDirection: "asc",
            filtro: {
                pesquisa: "",
            },
            arquivoLabel: "Selecionar Arquivo",
            arquivoNome: "",
            arquivos: null,
            lista: null,
            scanAberto: false,
        };
    },
    mounted() {
        // this.getCombos();
        this.list();
    },
    methods: {
        enterKey,
        dateFormat,

        handleEscolhaArquivo(e) {
            if (e.target.files.length > 0) {
                this.arquivoLabel = "";
                for (let i = 0; i < e.target.files.length; i++) {
                    const file = e.target.files[i];
                    this.arquivoLabel += '"' + file.name + '" ';
                }
                this.arquivoNome = e.target.files[0].name;
                this.arquivos = e.target.files;
            } else {
                this.arquivoLabel = "Selecionar Arquivo";
                this.arquivos = null;
            }
        },

        async getCombos() {
            this.carregando = true;

            try {
                // $("#filtrocard").collapse("hide");

                let { baseUrl } = this;
                let response = await api.get(`/${baseUrl}/combos`);

                this.combos = response.data;
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        async list() {
            this.carregando = true;

            try {
                // $("#filtrocard").collapse("hide");

                let { baseUrl, sort, sortDirection, filtro, perPage, pular } = this;
                let response = await api.get(`/${baseUrl}/`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular,
                    },
                });

                this.dados = response.data.listas;
                // this.totalRows = response.data.totalRows;

                setTimeout(() => {
                    selecionar('#pesquisa')
                }, 100);
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        async importarPlanilha() {
            this.carregando = true;

            try {
                $("#filtrocardImportacao").collapse("hide");

                let { baseUrl, arquivos } = this;
                const formData = new FormData();
                for (let i = 0; i < arquivos.length; i++) {
                    formData.append(`files[${i}]`, arquivos[i]);
                }

                await api.post(`/${baseUrl}/importar`, formData, {
                    headers: { "content-type": "multipart/form-data" },
                });

                this.dados = [];
                this.list();
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                    console.error(e);
                }
            }

            this.carregando = false;
        },

        async exportar() {
            try {
                const response = await this.apiExport();
                const today = new Date().toISOString().slice(0, 10);
                const fileName = `${this.title.text}_${today}.csv`;
                const blobURL = URL.createObjectURL(new File([response.data], fileName));
                const a = document.createElement("a");
                a.href = blobURL;
                a.style = "display: none";
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
            } catch (e) {
                console.error(e);
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }
            this.carregando = false;
        },

        async apiExport() {
            this.carregando = true;

            let { pular, perPage } = this;

            const response = await api.get(`/${this.baseUrl}/exportar`, {
                responseType: "blob",
                params: {
                    pular,
                    perPage,
                    sort: `${this.sort} ${this.sortDirection}`,
                    ...this.filtro,
                },
            });

            this.carregando = false;

            return response;
        },

        confimarLista(lista) {
            this.lista = lista;
            setTimeout(() => {
                $("#confirmarLista").modal("show");
            }, 100);
        },

        async okConfimarLista(idlista = null) {
            scrollToTop();
            $("#confirmarLista").modal("hide");
            let tocarSucesso = true;
            if (idlista === null) {
                idlista = this.lista.idlistascancelamento
                tocarSucesso = false
            }
            if (await this.verificarLista(idlista, tocarSucesso)) {
                this.$router.push('cancelamento/enderecos/' + idlista)
            }
        },

        abrirScan() {
            this.scanAberto = true;
            $("#scanModal").modal("show");
        },
        fecharScan() {
            this.scanAberto = false;
            $("#scanModal").modal("hide");
        },
        onDecode(r) {
            this.okConfimarLista(r)
            this.fecharScan();
        },
        onError(r) {
            console.log(r)
            alert("Não foi possível escanear")
        },
        onLoaded() {
            // $("#scanModal").modal("show");
        },

        async verificarLista(idlista, tocarSucesso) {
            this.carregando = true;

            try {
                // $("#filtrocard").collapse("hide");

                let { baseUrl, sort, sortDirection, filtro, perPage, pular } = this;
                await api.get(`/${baseUrl}/enderecos/${idlista}`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular,
                    },
                });

                this.carregando = false;
                if (tocarSucesso) {
                    // Audio.success()
                }
                return true
            } catch (e) {
                this.exception = e;
                if (e instanceof ValidationException) {
                    this.handleValidationException(e);
                } else if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ListaConcluidaException) {
                    this.message = e.message;
                    $("#warningModal").modal("show");
                    setTimeout(() => {
                        this.carregando = false;
                    }, 100);
                } else if (e instanceof EnderecoDiferenteException) {
                    this.$router.push('/picking/enderecos/' + this.id)
                } else if (e instanceof ClientErrorException) {
                    this.message = e.message;
                    this.errors.pesquisa = [e.message];
                    Audio.ops()
                    // $("#warningModal").modal("show");
                } else if (e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
                setTimeout(() => {
                    selecionar('#pesquisa')
                }, 100);
                console.error(e);
            }

            this.carregando = false;
            return false
        },
    },
};
</script>

<style scoped lang="scss">
.spinner-grow {
    width: 1em;
    height: 1em;
}

@media only screen and (min-width: 768px) {
}
</style>
